export default "__VITE_PUBLIC_ASSET__d111dc9c__"